import Vue from 'vue'
import VueRouter from 'vue-router'
import CheckResult from '../views/CheckResult.vue'
import Checks from '../views/Checks.vue'
import History from '../views/History.vue'
import Login from '../views/Login.vue'
import OAuthCallback from '../views/OAuthCallback.vue'

Vue.use(VueRouter)

const routes = [
  {
    alias: '/',
    path: '/check',
    name: 'Checks',
    component: Checks
  },
  {
    path: '/check/:id',
    name: 'CheckResult',
    meta: { layout: 'result' },
    component: CheckResult
  },
  {
    path: '/history',
    name: 'CheckHistory',
    meta: { layout: 'no-sidebar' },
    component: History
  },
  {
    path: '/login',
    name: 'Login',
    meta: { layout: 'empty' },
    component: Login
  },
  {
    path: '/oauth/linkedin/callback',
    name: 'OAuthCallback',
    meta: { layout: 'empty' },
    component: OAuthCallback
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
